module.exports = __webpack_public_path__ + "img/almuerzo_1.a6c31b8e.jpeg";